import { createUserWithEmailAndPassword } from "firebase/auth";
import React, { useState } from "react";
import { auth } from "../firebase.js";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "./Navbar.jsx";
import Footer from "./Footer.jsx";

const SignUp = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const signUp = async (e) => {
    e.preventDefault();
    try {
      const { user } = await createUserWithEmailAndPassword(auth, email, password);
      //await user.updateProfile({ displayName: name });
      if (!error){
        navigate('/rasas');
      }
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar/>
    <div className="container mx-auto flex flex-wrap justify-center pt-6">
      
      <form className="bg-white p-6 rounded-lg shadow-xl" onSubmit={signUp}>
        <div className="mb-4">
          <label
            className="block text-gray-700 font-medium mb-2"
            htmlFor="name"
          >
            Name
          </label>
          <input
            className="w-full border border-gray-400 p-2 rounded-md"
            id="name"
            type="text"
            placeholder="Enter your name"
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className="mb-4">
          <label
            className="block text-gray-700 font-medium mb-2"
            htmlFor="email"
          >
            Email
          </label>
          <input
                        className="w-full border border-gray-400 p-2 rounded-md"
                        id="email"
                        type="email"
                        placeholder="Enter your email"
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                    <div className="mb-4">
                      <label
                        className="block text-gray-700 font-medium mb-2"
                        htmlFor="password"
                      >
                        Password
                      </label>
                      <input
                        className="w-full border border-gray-400 p-2 rounded-md"
                        id="password"
                        type="password"
                        placeholder="Enter your password"
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </div>
                    <div className="text-red-500 text-xs mb-4">{error}</div>
                    <button
                      className="bg-indigo-500 hover:bg-indigo-600 text-white py-2 px-4 rounded-md"
                      type="submit"
                    >
                      Sign Up
                    </button>
                    <Link
                      to="/login"
                      className="text-indigo-500 hover:text-indigo-600 font-medium py-2 px-4"
                    >
                      Already have an account?
                    </Link>
      </form>
      
    </div>
      <Footer/>
    </div>
                
              );
            };
            
            export default SignUp;
            
